import { module } from 'angular';

import { STYLEGUIDE_STATES } from './styleguide.states';

module('spinnaker.core.styleguide', [STYLEGUIDE_STATES]);

export const STYLEGUIDE_MODULE = 'spinnaker.core.styleguide';
